import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { Phone, Email, Language } from '@mui/icons-material';

const FooterBlock = ({ data, isSelected, onUpdate, previewMode, blockId, onSelectBlock }) => {
  const {
    companyName = 'Your Company',
    address = '123 Main St, City, State 12345',
    phone = '',
    email = '',
    website = '',
    backgroundColor = '#f8f9fa',
    textColor = '#666666',
    fontSize = 12,
    padding = '30px 20px',
    marginTop = 0,
    marginBottom = 0,
    alignment = 'center',
    linkColor = '#007bff',
    fontFamily = 'Arial',
  } = data;

  const getResponsiveFontSize = () => {
    switch (previewMode) {
      case 'mobile':
        return Math.max(fontSize * 0.9, 10);
      case 'tablet':
        return Math.max(fontSize * 0.95, 11);
      default:
        return fontSize;
    }
  };

  const containerStyles = {
    backgroundColor,
    padding: `${padding}px`,
    marginTop: `${marginTop}px`,
    marginBottom: `${marginBottom}px`,
    textAlign: alignment,
    border: isSelected ? '1px dashed #007bff' : 'none',
    borderRadius: isSelected ? '4px' : 0,
  };

  const companyStyles = {
    fontWeight: 'bold',
    marginBottom: '8px',
    fontSize: `${getResponsiveFontSize() + 2}px`,
    color: textColor,
    fontFamily,
  };

  const addressStyles = {
    marginBottom: '15px',
    fontSize: `${getResponsiveFontSize()}px`,
    color: textColor,
    fontFamily,
  };

  const contactStyles = {
    fontSize: `${getResponsiveFontSize()}px`,
    color: linkColor,
    marginBottom: '5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: alignment,
    gap: '8px',
  };

  return (
    <Box sx={containerStyles}>
      <Typography sx={companyStyles}>
        {companyName}
      </Typography>
      
      <Typography sx={addressStyles}>
        {address}
      </Typography>
      
      {/* Contact Information */}
      {phone && (
        <Box sx={contactStyles}>
          <Phone sx={{ fontSize: '16px' }} />
          <Link href={`tel:${phone}`} sx={{ color: linkColor, textDecoration: 'none', fontFamily }}>
            {phone}
          </Link>
        </Box>
      )}
      
      {email && (
        <Box sx={contactStyles}>
          <Email sx={{ fontSize: '16px' }} />
          <Link href={`mailto:${email}`} sx={{ color: linkColor, textDecoration: 'none', fontFamily }}>
            {email}
          </Link>
        </Box>
      )}
      
      {website && (
        <Box sx={contactStyles}>
          <Language sx={{ fontSize: '16px' }} />
          <Link href={website} target="_blank" sx={{ color: linkColor, textDecoration: 'none', fontFamily }}>
            {website.replace(/^https?:\/\//, '')}
          </Link>
        </Box>
      )}
    </Box>
  );
};

export default FooterBlock; 